'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useState } from 'react';

import YouTube from 'react-youtube';
import { useParams } from 'next/navigation';
import { Locale } from 'shared/i18n/i18n-config';

function VideoPlayer({ videoId, placeHolderImg }: { videoId: string; placeHolderImg: string }): JSX.Element {
  const params = useParams<{ locale: Locale }>();
  const { locale }: { locale?: Locale } = params || {};
  const [overlayActive, setOverlayActive] = useState(true);
  const [player, setPlayer] = useState<any | null>(null);
  function startVideo() {
    if (player) player.playVideo();
    setOverlayActive(!overlayActive);
  }
  function playerToState({ target }) {
    setPlayer(target);
  }
  return videoId ? (
    <div id="video" className="shadow">
      <YouTube
        id="youTubeVideo"
        onReady={(e) => playerToState(e)}
        videoId={`${videoId}`}
        opts={{
          playerVars: {
            autoplay: 0,
            hl: locale,
            origin: 'https://www.youtube.com',
            // controls: 0,
          },
        }}
      />

      {overlayActive && (
        <div
          id="videoPlaceHolder"
          className="shadow"
          onKeyDown={startVideo}
          onClick={startVideo}
          style={{ backgroundImage: placeHolderImg ? `url(${placeHolderImg})` : 'none' }}
        >
          <button type="button" className="border-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="60" viewBox="0 0 50 60">
              <path id="Polygon_1" data-name="Polygon 1" d="M30,0,60,50H0Z" transform="translate(50) rotate(90)" fill="#fff" />
            </svg>
          </button>
        </div>
      )}
    </div>
  ) : (
    <></>
  );
}
export default VideoPlayer;
